import { api } from './BaseApi'
import {
  ICostHistoryRequest,
  ICostHistoryResponse,
} from './dto/CostHistoryDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const costHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCostHistory: builder.query<ICostHistoryResponse, ICostHistoryRequest>({
      query: (params) => ({
        url: `/buffet_dish/get_cost_history/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['ВuffetDish'],
    }),
  }),
})

export const { useGetCostHistoryQuery } = costHistoryApi
